export interface FightResult {
  winner: 'fighter1' | 'fighter2' | 'draw' | 'no_contest'
  method: string
  round: number
  time: string
}

export interface Fight {
  id: number
  fighter1: string
  fighter2: string
  weightClass: string
  isMainEvent: boolean
  isTitleFight: boolean
  result?: FightResult
}

export interface Event {
  id: number
  name: string
  date: string
  location: string
  venue: string
  mainEvent: string
  status: 'upcoming' | 'live' | 'completed'
  broadcast: string
  fights: Fight[]
}

export const events: Event[] = [
  {
    id: 1,
    name: 'UFC 310',
    date: '2024-12-07',
    location: 'Las Vegas, Nevada',
    venue: 'T-Mobile Arena',
    mainEvent: 'Pantoja vs Asakura',
    status: 'upcoming',
    broadcast: 'ESPN+ PPV',
    fights: [
      { id: 1, fighter1: 'Alexandre Pantoja', fighter2: 'Kai Asakura', weightClass: 'Flyweight', isMainEvent: true, isTitleFight: true },
      { id: 2, fighter1: 'Shavkat Rakhmonov', fighter2: 'Ian Machado Garry', weightClass: 'Welterweight', isMainEvent: false, isTitleFight: false },
      { id: 3, fighter1: 'Ciryl Gane', fighter2: 'Alexander Volkov', weightClass: 'Heavyweight', isMainEvent: false, isTitleFight: false },
      { id: 4, fighter1: 'Bryce Mitchell', fighter2: 'Kron Gracie', weightClass: 'Featherweight', isMainEvent: false, isTitleFight: false },
      { id: 5, fighter1: 'Nate Landwehr', fighter2: 'Dooho Choi', weightClass: 'Featherweight', isMainEvent: false, isTitleFight: false }
    ]
  },
  {
    id: 2,
    name: 'UFC 311',
    date: '2025-01-18',
    location: 'Los Angeles, California',
    venue: 'Intuit Dome',
    mainEvent: 'Makhachev vs Tsarukyan 2',
    status: 'upcoming',
    broadcast: 'ESPN+ PPV',
    fights: [
      { id: 1, fighter1: 'Islam Makhachev', fighter2: 'Arman Tsarukyan', weightClass: 'Lightweight', isMainEvent: true, isTitleFight: true },
      { id: 2, fighter1: 'Merab Dvalishvili', fighter2: 'Umar Nurmagomedov', weightClass: 'Bantamweight', isMainEvent: false, isTitleFight: true },
      { id: 3, fighter1: 'Jiri Prochazka', fighter2: 'Jamahal Hill', weightClass: 'Light Heavyweight', isMainEvent: false, isTitleFight: false },
      { id: 4, fighter1: 'Kevin Holland', fighter2: 'Reinier de Ridder', weightClass: 'Middleweight', isMainEvent: false, isTitleFight: false }
    ]
  },
  {
    id: 3,
    name: 'UFC 312',
    date: '2025-02-08',
    location: 'Sydney, Australia',
    venue: 'Qudos Bank Arena',
    mainEvent: 'Du Plessis vs Strickland 2',
    status: 'upcoming',
    broadcast: 'ESPN+ PPV',
    fights: [
      { id: 1, fighter1: 'Dricus Du Plessis', fighter2: 'Sean Strickland', weightClass: 'Middleweight', isMainEvent: true, isTitleFight: true },
      { id: 2, fighter1: 'Tai Tuivasa', fighter2: 'Jairzinho Rozenstruik', weightClass: 'Heavyweight', isMainEvent: false, isTitleFight: false },
      { id: 3, fighter1: 'Jimmy Crute', fighter2: 'Alonzo Menifield', weightClass: 'Light Heavyweight', isMainEvent: false, isTitleFight: false }
    ]
  },
  {
    id: 4,
    name: 'UFC Fight Night',
    date: '2024-11-30',
    location: 'Las Vegas, Nevada',
    venue: 'UFC APEX',
    mainEvent: 'Covington vs Buckley',
    status: 'completed',
    broadcast: 'ESPN+',
    fights: [
      { id: 1, fighter1: 'Colby Covington', fighter2: 'Joaquin Buckley', weightClass: 'Welterweight', isMainEvent: true, isTitleFight: false, result: { winner: 'fighter2', method: 'KO/TKO', round: 3, time: '4:32' } },
      { id: 2, fighter1: 'Marina Rodriguez', fighter2: 'Iasmin Lucindo', weightClass: 'Strawweight', isMainEvent: false, isTitleFight: false, result: { winner: 'fighter1', method: 'Unanimous Decision', round: 3, time: '5:00' } },
      { id: 3, fighter1: 'Cub Swanson', fighter2: 'Billy Quarantillo', weightClass: 'Featherweight', isMainEvent: false, isTitleFight: false, result: { winner: 'fighter1', method: 'Split Decision', round: 3, time: '5:00' } }
    ]
  },
  {
    id: 5,
    name: 'UFC 309',
    date: '2024-11-16',
    location: 'New York, New York',
    venue: 'Madison Square Garden',
    mainEvent: 'Jones vs Miocic',
    status: 'completed',
    broadcast: 'ESPN+ PPV',
    fights: [
      { id: 1, fighter1: 'Jon Jones', fighter2: 'Stipe Miocic', weightClass: 'Heavyweight', isMainEvent: true, isTitleFight: true, result: { winner: 'fighter1', method: 'KO/TKO', round: 3, time: '4:29' } },
      { id: 2, fighter1: 'Charles Oliveira', fighter2: 'Michael Chandler', weightClass: 'Lightweight', isMainEvent: false, isTitleFight: false, result: { winner: 'fighter1', method: 'Submission', round: 1, time: '3:08' } },
      { id: 3, fighter1: 'Bo Nickal', fighter2: 'Paul Craig', weightClass: 'Middleweight', isMainEvent: false, isTitleFight: false, result: { winner: 'fighter1', method: 'Submission', round: 1, time: '1:32' } },
      { id: 4, fighter1: 'Viviane Araujo', fighter2: 'Natalia Silva', weightClass: 'Flyweight', isMainEvent: false, isTitleFight: false, result: { winner: 'fighter2', method: 'Unanimous Decision', round: 3, time: '5:00' } }
    ]
  },
  {
    id: 6,
    name: 'UFC 313',
    date: '2025-03-08',
    location: 'Las Vegas, Nevada',
    venue: 'T-Mobile Arena',
    mainEvent: 'Pereira vs Ankalaev',
    status: 'upcoming',
    broadcast: 'ESPN+ PPV',
    fights: [
      { id: 1, fighter1: 'Alex Pereira', fighter2: 'Magomed Ankalaev', weightClass: 'Light Heavyweight', isMainEvent: true, isTitleFight: true },
      { id: 2, fighter1: 'Curtis Blaydes', fighter2: 'Tom Aspinall', weightClass: 'Heavyweight', isMainEvent: false, isTitleFight: false },
      { id: 3, fighter1: 'Dustin Poirier', fighter2: 'Dan Hooker', weightClass: 'Lightweight', isMainEvent: false, isTitleFight: false }
    ]
  }
]

export function getEventById(id: number): Event | undefined {
  return events.find(e => e.id === id)
}
